import { OptimizerRunV2State } from '@generated/graphql';
import type { BadgeProps } from '@ovComponents/2-component/badge/badge';

export const getRunStateBadgeColor = (
  state: OptimizerRunV2State,
): BadgeProps['color'] => {
  switch (state) {
    case OptimizerRunV2State.Completed:
      return 'positive';
    case OptimizerRunV2State.Failed:
      return 'negative';
    case OptimizerRunV2State.Initiated:
    case OptimizerRunV2State.Optimizing:
    case OptimizerRunV2State.Validating:
    case OptimizerRunV2State.Publishing:
      return 'warning';
    default:
      return 'neutral';
  }
};
